import React, { useEffect, useState } from "react";
import "./FormFillUpStep2.css";
import HomeServices from "../../Services/HomeServices";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const FormFillUpStep2 = () => {
  const [loading, setLoading] = useState(false);
  const [primaryApplicantData, setPrimaryApplicantData] = useState([]);
  const [extraFields, setExtraFields] = useState({});
  const [alreadyExistedData, setAlreadyExistedData] = useState(false);
  const [existedDataId, setExistedDataId] = useState("");
  const [applicantId, setApplicantId] = useState("");
  const [childCount, setChildCount] = useState(0);
  const navigate = useNavigate();

  // Consolidated state object - aligned with Postman body
  const [formData, setFormData] = useState({
    // Personal Information
    firstName: "",
    middleName: "",
    lastName: "",
    otherName: "",
    nativeLanguage: "",
    gender: "",
    dateOfBirth: "",
    countryOfBirth: "",
    cityOfBirth: "",
    countryOfCitizenship: "",
    currentCountryOfResidence: "",

    // Marital Information
    maritalStatus: "",
    spouseCount: 1,
    childCount: "",
    dateOfMarriage: "",

    // Passport Information
    passportNo: "",
    issueDate: "",
    expiryDate: "",
    countryOfIssue: "",

    // Contact Information
    telephoneNo: "",
    emailId: "",
    mailingAddress: "",
    permanentAddress: "",

    // Canadian Immigration Information
    UCIno: "",
    firstTimeEnteredInCanada: "",
    placeOfEnteredInCanada: "",
    lastTimeEnteredInCanada: "",
    totalFamilyMemberIncludingSpouseAndChild: "",
    provinceOfConsiderLiving: "",

    // Application History
    didAppliedToExpressEntryCanadaBefore: "",
    EEno: "",
    receivedNominationCertificateFromProvinceOrTerritory: "",
    moneyBroughtToCanada: "",

    // Relatives in Canada
    relativesInCanada: "",
    relativesInCanadaResidentWith: "",
    relativesInCanadaWithCitizenOrPermanentResidentOfCanada: "",
    name: "",
    relation: "",
    statusInCanada: "",
    cityOrProvinceOfResidence: "",

    // Immigration History Questions - Individual fields
    HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada:
      "",
    HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry:
      "",
    UNHCR: "",
    CSQ: "",
    HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry:
      "",
    HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity:
      "",
    HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives:
      "",
    HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives:
      "",
    HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity:
      "",
    HasApplicantBeenDetainedIncarceratedorPutinJail: "",
    HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder: "",

    // Remarks fields for "Yes" answers
    HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks:
      "",
    HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks:
      "",
    UNHCRRemarks: "",
    CSQRemarks: "",
    HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks:
      "",
    HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks:
      "",
    HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks:
      "",
    HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks:
      "",
    HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks:
      "",
    HasApplicantBeenDetainedIncarceratedorPutinJailRemarks: "",
    HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks: "",
  });

  // Immigration history questions mapping
  const immigrationQuestions = [
    {
      id: 1,
      text: "Has Applicant's been convicted of a crime or offence in Canada for which a pardon has not been granted under the Criminal Records Act of Canada?",
      field:
        "HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada",
      remarksField:
        "HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks",
    },
    {
      id: 2,
      text: "Has Applicant's ever committed, been arrested for, been charged with or convicted of any criminal offence in any country?",
      field:
        "HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry",
      remarksField:
        "HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks",
    },
    {
      id: 3,
      text: "Has Applicant's made previous claims for refugee protection in Canada or at a Canadian visa office abroad, in any other country or countries, or with the United Nations High Commissioner for Refugees (UNHCR)?",
      field: "UNHCR",
      remarksField: "UNHCRRemarks",
    },
    {
      id: 4,
      text: "Has Applicant's been refused refugee status, or an immigrant or permanent resident visa (including a Certificat de sélection du Québec (CSQ) or application to the Provincial nominee Program) or visitor or temporary resident visa, to Canada or any other country?",
      field:
        "HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry",
      remarksField:
        "HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks",
    },
    {
      id: 5,
      text: "Has Applicant's been involved in an act of genocide, a war crime or in the commission of a crime against humanity?",
      field:
        "HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity",
      remarksField:
        "HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks",
    },
    {
      id: 6,
      text: "Has Applicant's used, planned or advocated the use of armed struggle or violence to reach political, religious or social objectives?",
      field:
        "HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives",
      remarksField:
        "HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks",
    },
    {
      id: 7,
      text: "Has Applicant's been associated with a group that used, uses, advocated or advocates the use of armed struggle or violence to reach political, religious or social objectives?",
      field:
        "HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives",
      remarksField:
        "HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks",
    },
    {
      id: 8,
      text: "Has Applicant's been a member of an organization that is or was engaged in an activity that is part of a pattern of criminal activity?",
      field:
        "HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity",
      remarksField:
        "HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks",
    },
    {
      id: 9,
      text: "Has Applicant's been detained, incarcerated, or put in jail?",
      field: "HasApplicantBeenDetainedIncarceratedorPutinJail",
      remarksField: "HasApplicantBeenDetainedIncarceratedorPutinJailRemarks",
    },
    {
      id: 10,
      text: "Has Applicant's had any serious disease or physical or mental disorder?",
      field: "HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder",
      remarksField:
        "HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks",
    },
  ];

  const fetchApplicantData = async () => {
    try {
      setLoading(true);
      const res = await HomeServices.getPrimariApplicantData();
      console.log("Data of spouse", res);
      if (res?.status) {
        setApplicantId(res?.data[0]?.PrimaryApplicantData?._id);
        setChildCount(res?.data[0]?.PrimaryApplicantData?.childCount);
      }
      if (
        res?.status &&
        res?.data &&
        res.data.length > 0 &&
        res?.data[0]?.PrimaryApplicantData?.PrimaryApplicantSpouseData?._id
      ) {
        // setAlreadyExistedData(true);
        setAlreadyExistedData(
          res?.data[0]?.PrimaryApplicantData?.PrimaryApplicantSpouseData?._id
            ? true
            : false,
        );
        setExistedDataId(
          res?.data[0]?.PrimaryApplicantData?.PrimaryApplicantSpouseData?._id,
        );

        const userData = res.data[0];
        const primaryData =
          userData?.PrimaryApplicantData?.PrimaryApplicantSpouseData;

        if (primaryData) {
          // Create a new object to hold the mapped data
          const mappedData = {};

          // Map all fields from API to formData
          Object.keys(formData).forEach((field) => {
            if (primaryData[field] !== undefined) {
              let value = primaryData[field];

              // Handle date fields - convert from ISO format to YYYY-MM-DD
              if (
                field === "dateOfBirth" ||
                field === "dateOfMarriage" ||
                field === "issueDate" ||
                field === "expiryDate" ||
                field === "firstTimeEnteredInCanada" ||
                field === "lastTimeEnteredInCanada"
              ) {
                if (value && typeof value === "string") {
                  // Extract YYYY-MM-DD from ISO string
                  const dateMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
                  if (dateMatch) {
                    value = dateMatch[1];
                  }
                }
              }

              // Handle numeric fields
              if (
                field === "UCIno" ||
                field === "EEno" ||
                field === "spouseCount" ||
                field === "childCount" ||
                field === "totalFamilyMemberIncludingSpouseAndChild" ||
                field === "telephoneNo"
              ) {
                value = value?.toString() || "";
              }

              mappedData[field] = value || "";
            } else {
              mappedData[field] = "";
            }
          });

          // Set the form data with mapped values
          setFormData((prev) => ({
            ...prev,
            ...mappedData,
          }));

          setPrimaryApplicantData(res.data);
          toast.success("Spouse data loaded successfully!");
        } else {
          // toast.error("No spouse data found.");
          console.log("No Spouse data found");
        }
      } else {
        // toast.error("No data available.");
        console.log("No data available.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to load spouse data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplicantData();
  }, []);

  // Handle form field changes
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle immigration history field changes
  const handleImmigrationFieldChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // If user selects "No", clear the corresponding remarks field
    if (value === "No") {
      const question = immigrationQuestions.find((q) => q.field === field);
      if (question && question.remarksField) {
        setFormData((prev) => ({
          ...prev,
          [question.remarksField]: "",
        }));
      }

      // Special handling for CSQ field
      if (field === "CSQ" && value === "No") {
        setFormData((prev) => ({
          ...prev,
          CSQRemarks: "",
        }));
      }
    }
  };

  // Handle remarks field changes
  const handleRemarksChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare submission data according to Postman body structure
    const submissionData = {
      // Personal Information
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      otherName: formData.otherName,
      nativeLanguage: formData.nativeLanguage,
      gender: formData.gender,
      dateOfBirth: formData.dateOfBirth,
      countryOfBirth: formData.countryOfBirth,
      cityOfBirth: formData.cityOfBirth,
      countryOfCitizenship: formData.countryOfCitizenship,
      currentCountryOfResidence: formData.currentCountryOfResidence,

      // Marital Information
      maritalStatus: formData.maritalStatus,
      spouseCount: formData.spouseCount ? parseInt(formData.spouseCount) : 1,
      childCount: formData.childCount ? parseInt(formData.childCount) : "",
      dateOfMarriage: formData.dateOfMarriage,

      // Passport Information
      passportNo: formData.passportNo,
      issueDate: formData.issueDate,
      expiryDate: formData.expiryDate,
      countryOfIssue: formData.countryOfIssue,

      // Contact Information
      telephoneNo: formData.telephoneNo,
      emailId: formData.emailId,
      mailingAddress: formData.mailingAddress,
      permanentAddress: formData.permanentAddress,

      // Canadian Immigration Information
      UCIno: formData.UCIno ? parseInt(formData.UCIno) : "",
      firstTimeEnteredInCanada: formData.firstTimeEnteredInCanada,
      placeOfEnteredInCanada: formData.placeOfEnteredInCanada,
      lastTimeEnteredInCanada: formData.lastTimeEnteredInCanada,
      totalFamilyMemberIncludingSpouseAndChild:
        formData.totalFamilyMemberIncludingSpouseAndChild
          ? parseInt(formData.totalFamilyMemberIncludingSpouseAndChild)
          : "",
      provinceOfConsiderLiving: formData.provinceOfConsiderLiving,

      // Application History
      didAppliedToExpressEntryCanadaBefore:
        formData.didAppliedToExpressEntryCanadaBefore,
      EEno: formData.EEno ? parseInt(formData.EEno) : "",
      receivedNominationCertificateFromProvinceOrTerritory:
        formData.receivedNominationCertificateFromProvinceOrTerritory,
      moneyBroughtToCanada: formData.moneyBroughtToCanada,

      // Relatives in Canada
      relativesInCanadaWithCitizenOrPermanentResidentOfCanada:
        formData.relativesInCanadaWithCitizenOrPermanentResidentOfCanada,
      relativesInCanada: formData?.relativesInCanada,
      name: formData.name,
      relation: formData.relation,
      statusInCanada: formData.statusInCanada,
      cityOrProvinceOfResidence: formData.cityOrProvinceOfResidence,
      relativesInCanadaResidentWith: formData?.relativesInCanadaResidentWith,

      // Immigration History
      HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada:
        formData.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada,
      HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry:
        formData.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry,
      UNHCR: formData.UNHCR,
      CSQ: formData.CSQ,
      HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry:
        formData.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry,
      HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity:
        formData.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity,
      HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives:
        formData.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives,
      HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives:
        formData.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives,
      HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity:
        formData.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity,
      HasApplicantBeenDetainedIncarceratedorPutinJail:
        formData.HasApplicantBeenDetainedIncarceratedorPutinJail,
      HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder:
        formData.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder,

      // Remarks fields
      HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks:
        formData.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks,
      HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks:
        formData.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks,
      UNHCRRemarks: formData.UNHCRRemarks,
      CSQRemarks: formData.CSQRemarks,
      HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks:
        formData.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks,
      HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks:
        formData.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks,
      HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks:
        formData.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks,
      HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks:
        formData.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks,
      HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks:
        formData.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks,
      HasApplicantBeenDetainedIncarceratedorPutinJailRemarks:
        formData.HasApplicantBeenDetainedIncarceratedorPutinJailRemarks,
      HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks:
        formData.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks,

      // Primary applicant id
      primaryApplicantId: applicantId,
    };

    console.log("submitted data", submissionData);

    try {
      setLoading(true);
      const res = !alreadyExistedData
        ? await HomeServices?.createPrimaryApplicantSpouseData(submissionData)
        : await HomeServices?.updatePrimaryApplicantSpouseData(
            submissionData,
            existedDataId,
          );
      console.log("Response:", res);
      if (res?.status) {
        toast.success(
          alreadyExistedData
            ? "Spouse data updated successfully!"
            : "Spouse data created successfully!",
        );
        if (childCount > 0) {
          navigate("/form-fill-up-step3-child-details");
        } else {
          navigate("/form-fill-up-step4-education-history");
        }
      } else {
        toast.error(res?.message || "Operation failed");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to submit spouse data");
    } finally {
      setLoading(false);
    }
  };

  // Render immigration history section
  const renderImmigrationHistory = () => {
    return (
      <div className="tab-content">
        <div className="questions-header">
          <h3>Immigration History Questions</h3>
          <p className="instructions">
            Answer YES/NO for each question. If yes, provide details.
          </p>
        </div>

        <div className="questions-container">
          {immigrationQuestions.map((question) => (
            <div key={question.id} className="question-group">
              <div className="question-text">
                <span className="question-number">{question.id}.</span>
                <span>{question.text}</span>
              </div>

              <div className="question-response">
                <div className="answer-select">
                  <select
                    value={formData[question.field] || ""}
                    onChange={(e) =>
                      handleImmigrationFieldChange(
                        question.field,
                        e.target.value,
                      )
                    }
                    className="answer-dropdown"
                  >
                    <option value="">Select</option>
                    <option value="Yes">YES</option>
                    <option value="No">NO</option>
                  </select>
                </div>
              </div>

              {/* Show remarks textarea if answer is "Yes" */}
              {question.remarksField && formData[question.field] === "Yes" && (
                <div className="remarks-section">
                  <label className="remarks-label">
                    Please provide details:
                  </label>
                  <textarea
                    value={formData[question.remarksField] || ""}
                    onChange={(e) =>
                      handleRemarksChange(question.remarksField, e.target.value)
                    }
                    placeholder="Enter details..."
                    rows="3"
                    className="remarks-textarea"
                  />
                </div>
              )}
            </div>
          ))}

          {/* CSQ field - Separate from the immigrationQuestions array */}
          <div className="question-group">
            <div className="question-text">
              <span className="question-number">11.</span>
              <span>
                Has Applicant received a Certificat de sélection du Québec
                (CSQ)?
              </span>
            </div>

            <div className="question-response">
              <div className="answer-select">
                <select
                  value={formData.CSQ || ""}
                  onChange={(e) =>
                    handleImmigrationFieldChange("CSQ", e.target.value)
                  }
                  className="answer-dropdown"
                >
                  <option value="">Select</option>
                  <option value="Yes">YES</option>
                  <option value="No">NO</option>
                </select>
              </div>
            </div>

            {/* Show remarks textarea if CSQ answer is "Yes" */}
            {formData.CSQ === "Yes" && (
              <div className="remarks-section">
                <label className="remarks-label">
                  Please provide CSQ details:
                </label>
                <textarea
                  value={formData.CSQRemarks || ""}
                  onChange={(e) =>
                    handleRemarksChange("CSQRemarks", e.target.value)
                  }
                  placeholder="Enter CSQ details..."
                  rows="3"
                  className="remarks-textarea"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <h1>Canadian Immigration Application - Spouse Details</h1>
        <p>
          Please fill in all the required information. All fields are optional.
        </p>
      </div>

      {loading && (
        <div className="loading-indicator">
          <p>{alreadyExistedData ? "Updating..." : "Submitting..."}</p>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-columns">
          {/* Left Column */}
          <div className="form-column">
            <h2 className="section-title">Personal Information</h2>

            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                value={formData.firstName}
                onChange={(e) => handleChange("firstName", e.target.value)}
                placeholder="Enter your first name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="middleName">Middle Name</label>
              <input
                type="text"
                id="middleName"
                value={formData.middleName}
                onChange={(e) => handleChange("middleName", e.target.value)}
                placeholder="Enter your middle name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastName">Last Name/Surname</label>
              <input
                type="text"
                id="lastName"
                value={formData.lastName}
                onChange={(e) => handleChange("lastName", e.target.value)}
                placeholder="Enter your last name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="otherName">Any other name used in Past</label>
              <input
                type="text"
                id="otherName"
                value={formData.otherName}
                onChange={(e) => handleChange("otherName", e.target.value)}
                placeholder="Enter any other names you've used"
              />
            </div>

            <div className="form-group">
              <label htmlFor="nativeLanguage">Native Language</label>
              <input
                type="text"
                id="nativeLanguage"
                value={formData.nativeLanguage}
                onChange={(e) => handleChange("nativeLanguage", e.target.value)}
                placeholder="Enter your native language"
              />
            </div>

            <div className="form-group">
              <label htmlFor="gender">Gender</label>
              <select
                id="gender"
                value={formData.gender}
                onChange={(e) => handleChange("gender", e.target.value)}
              >
                <option value="">Select gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="dateOfBirth">Date of Birth</label>
              <input
                type="date"
                id="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={(e) => handleChange("dateOfBirth", e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="countryOfBirth">Country Of Birth</label>
              <input
                type="text"
                id="countryOfBirth"
                value={formData.countryOfBirth}
                onChange={(e) => handleChange("countryOfBirth", e.target.value)}
                placeholder="Enter your country of birth"
              />
            </div>

            <div className="form-group">
              <label htmlFor="cityOfBirth">City/Town of Birth</label>
              <input
                type="text"
                id="cityOfBirth"
                value={formData.cityOfBirth}
                onChange={(e) => handleChange("cityOfBirth", e.target.value)}
                placeholder="Enter your city/town of birth"
              />
            </div>

            <div className="form-group">
              <label htmlFor="countryOfCitizenship">
                Country Of Citizenship
              </label>
              <input
                type="text"
                id="countryOfCitizenship"
                value={formData.countryOfCitizenship}
                onChange={(e) =>
                  handleChange("countryOfCitizenship", e.target.value)
                }
                placeholder="Enter your country of citizenship"
              />
            </div>

            <div className="form-group">
              <label htmlFor="currentCountryOfResidence">
                Current Country of Residence
              </label>
              <input
                type="text"
                id="currentCountryOfResidence"
                value={formData.currentCountryOfResidence}
                onChange={(e) =>
                  handleChange("currentCountryOfResidence", e.target.value)
                }
                placeholder="Enter your current country of residence"
              />
            </div>

            <h2 className="section-title">Marital Information</h2>

            <div className="form-group">
              <label htmlFor="maritalStatus">Marital Status</label>
              <select
                id="maritalStatus"
                value={formData.maritalStatus}
                onChange={(e) => handleChange("maritalStatus", e.target.value)}
              >
                <option value="">Select marital status</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="widow">Widow</option>
                <option value="divorced">Divorced</option>
                <option value="separated">Separated</option>
              </select>
            </div>

            {formData.maritalStatus === "married" && (
              <>
                <div className="form-group">
                  <label htmlFor="spouseCount">Number of Spouses</label>
                  <input
                    readOnly
                    type="number"
                    id="spouseCount"
                    value={formData.spouseCount}
                    onChange={(e) =>
                      handleChange("spouseCount", e.target.value)
                    }
                    placeholder="Enter number of spouses"
                    min="1"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="childCount">Number of children</label>
                  <input
                    type="number"
                    id="childCount"
                    value={formData.childCount}
                    onChange={(e) => handleChange("childCount", e.target.value)}
                    placeholder="Enter number of children"
                    min="0"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="dateOfMarriage">Date of Marriage</label>
                  <input
                    type="date"
                    id="dateOfMarriage"
                    value={formData.dateOfMarriage}
                    onChange={(e) =>
                      handleChange("dateOfMarriage", e.target.value)
                    }
                  />
                </div>
              </>
            )}

            {(formData.maritalStatus === "widow" ||
              formData.maritalStatus === "divorced" ||
              formData.maritalStatus === "separated") && (
              <div className="form-group">
                <label htmlFor="childCount">Number of children</label>
                <input
                  type="number"
                  id="childCount"
                  value={formData.childCount}
                  onChange={(e) => handleChange("childCount", e.target.value)}
                  placeholder="Enter number of children"
                  min="0"
                />
              </div>
            )}

            <h2 className="section-title">Passport Information</h2>

            <div className="form-group">
              <label htmlFor="passportNo">Passport Number</label>
              <input
                type="text"
                id="passportNo"
                value={formData.passportNo}
                onChange={(e) => handleChange("passportNo", e.target.value)}
                placeholder="Enter your passport number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="issueDate">Issue Date</label>
              <input
                type="date"
                id="issueDate"
                value={formData.issueDate}
                onChange={(e) => handleChange("issueDate", e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="expiryDate">Expiry Date</label>
              <input
                type="date"
                id="expiryDate"
                value={formData.expiryDate}
                onChange={(e) => handleChange("expiryDate", e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="countryOfIssue">Country Of Issue</label>
              <input
                type="text"
                id="countryOfIssue"
                value={formData.countryOfIssue}
                onChange={(e) => handleChange("countryOfIssue", e.target.value)}
                placeholder="Enter country of passport issue"
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="form-column">
            <h2 className="section-title">Contact Information</h2>

            <div className="form-group">
              <label htmlFor="telephoneNo">Telephone Number</label>
              <input
                type="text"
                id="telephoneNo"
                value={formData.telephoneNo}
                onChange={(e) => handleChange("telephoneNo", e.target.value)}
                placeholder="Enter your telephone number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="emailId">Email ID</label>
              <input
                type="email"
                id="emailId"
                value={formData.emailId}
                onChange={(e) => handleChange("emailId", e.target.value)}
                placeholder="Enter your email address"
              />
            </div>

            <div className="form-group">
              <label htmlFor="mailingAddress">Mailing Address</label>
              <textarea
                id="mailingAddress"
                value={formData.mailingAddress}
                onChange={(e) => handleChange("mailingAddress", e.target.value)}
                placeholder="Enter your complete mailing address"
                rows="3"
              />
            </div>

            <div className="form-group">
              <label htmlFor="permanentAddress">Permanent Address</label>
              <textarea
                id="permanentAddress"
                value={formData.permanentAddress}
                onChange={(e) =>
                  handleChange("permanentAddress", e.target.value)
                }
                placeholder="Enter your complete permanent address"
                rows="3"
              />
            </div>

            <h2 className="section-title">Canadian Immigration Information</h2>

            <div className="form-group">
              <label htmlFor="UCIno">UCI Number</label>
              <input
                type="text"
                id="UCIno"
                value={formData.UCIno}
                onChange={(e) => handleChange("UCIno", e.target.value)}
                placeholder="Enter your UCI number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="firstTimeEnteredInCanada">
                First Entry Date to Canada
              </label>
              <input
                type="date"
                id="firstTimeEnteredInCanada"
                value={formData.firstTimeEnteredInCanada}
                onChange={(e) =>
                  handleChange("firstTimeEnteredInCanada", e.target.value)
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="placeOfEnteredInCanada">
                Place of First Entry to Canada
              </label>
              <input
                type="text"
                id="placeOfEnteredInCanada"
                value={formData.placeOfEnteredInCanada}
                onChange={(e) =>
                  handleChange("placeOfEnteredInCanada", e.target.value)
                }
                placeholder="Enter place of first entry"
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastTimeEnteredInCanada">
                Last Entry Date to Canada
              </label>
              <input
                type="date"
                id="lastTimeEnteredInCanada"
                value={formData.lastTimeEnteredInCanada}
                onChange={(e) =>
                  handleChange("lastTimeEnteredInCanada", e.target.value)
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="totalFamilyMemberIncludingSpouseAndChild">
                Family Members in Application
              </label>
              <input
                type="number"
                id="totalFamilyMemberIncludingSpouseAndChild"
                value={formData.totalFamilyMemberIncludingSpouseAndChild}
                onChange={(e) =>
                  handleChange(
                    "totalFamilyMemberIncludingSpouseAndChild",
                    e.target.value,
                  )
                }
                placeholder="Enter number of family members"
                min="1"
              />
            </div>

            <div className="form-group">
              <label htmlFor="provinceOfConsiderLiving">
                Preferred Province
              </label>
              <input
                type="text"
                id="provinceOfConsiderLiving"
                value={formData.provinceOfConsiderLiving}
                onChange={(e) =>
                  handleChange("provinceOfConsiderLiving", e.target.value)
                }
                placeholder="Enter preferred province for living"
              />
            </div>

            <h2 className="section-title">Application History</h2>

            <div className="form-group">
              <label htmlFor="didAppliedToExpressEntryCanadaBefore">
                Applied to Express Entry Before?
              </label>
              <select
                id="didAppliedToExpressEntryCanadaBefore"
                value={formData.didAppliedToExpressEntryCanadaBefore}
                onChange={(e) =>
                  handleChange(
                    "didAppliedToExpressEntryCanadaBefore",
                    e.target.value,
                  )
                }
              >
                <option value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {formData.didAppliedToExpressEntryCanadaBefore === "Yes" && (
              <div className="form-group">
                <label htmlFor="EEno">Express Entry Number</label>
                <input
                  type="text"
                  id="EEno"
                  value={formData.EEno}
                  onChange={(e) => handleChange("EEno", e.target.value)}
                  placeholder="Enter your Express Entry number"
                />
              </div>
            )}

            <div className="form-group">
              <label htmlFor="receivedNominationCertificateFromProvinceOrTerritory">
                Received Nomination Certificate?
              </label>
              <select
                id="receivedNominationCertificateFromProvinceOrTerritory"
                value={
                  formData.receivedNominationCertificateFromProvinceOrTerritory
                }
                onChange={(e) =>
                  handleChange(
                    "receivedNominationCertificateFromProvinceOrTerritory",
                    e.target.value,
                  )
                }
              >
                <option value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="moneyBroughtToCanada">
                Funds for Canada (CAD)
              </label>
              <input
                type="text"
                id="moneyBroughtToCanada"
                value={formData.moneyBroughtToCanada}
                onChange={(e) =>
                  handleChange("moneyBroughtToCanada", e.target.value)
                }
                placeholder="Enter amount in CAD"
              />
            </div>

            <h2 className="section-title">Relatives in Canada</h2>

            <div className="form-group">
              <label htmlFor="relativesInCanadaWithCitizenOrPermanentResidentOfCanada">
                Relatives in Canada? (18+ years)
              </label>
              <select
                id="relativesInCanadaWithCitizenOrPermanentResidentOfCanada"
                value={
                  // formData.relativesInCanadaWithCitizenOrPermanentResidentOfCanada
                  formData?.relativesInCanada
                }
                onChange={(e) =>
                  handleChange("relativesInCanada", e.target.value)
                }
              >
                <option value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {/* {formData.relativesInCanadaWithCitizenOrPermanentResidentOfCanada === */}
            {formData.relativesInCanada === "Yes" && (
              <>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                    placeholder="Enter relative's name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="relation">Relation</label>
                  <input
                    type="text"
                    id="relation"
                    value={formData.relation}
                    onChange={(e) => handleChange("relation", e.target.value)}
                    placeholder="Enter your relationship"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="statusInCanada">Status in Canada</label>
                  <input
                    type="text"
                    id="statusInCanada"
                    value={formData.statusInCanada}
                    onChange={(e) =>
                      handleChange("statusInCanada", e.target.value)
                    }
                    placeholder="Enter relative's status"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="cityOrProvinceOfResidence">
                    City/Province of Residence
                  </label>
                  <input
                    type="text"
                    id="cityOrProvinceOfResidence"
                    value={formData.cityOrProvinceOfResidence}
                    onChange={(e) =>
                      handleChange("cityOrProvinceOfResidence", e.target.value)
                    }
                    placeholder="Enter relative's location"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="cityOrProvinceOfResidence">
                    Status of the Relative
                  </label>
                  <select
                    id="relativesInCanadaWithCitizenOrPermanentResidentOfCanada"
                    value={formData?.relativesInCanadaResidentWith}
                    onChange={(e) =>
                      handleChange(
                        "relativesInCanadaResidentWith",
                        e.target.value,
                      )
                    }
                  >
                    <option value="">Select option</option>
                    <option value="Citizen">Citizen</option>
                    <option value="Permanent">Permanent Resident</option>
                  </select>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Immigration History Section - Added below the two columns */}
        <div className="immigration-history-section">
          <h2 className="section-title">Immigration History</h2>
          {renderImmigrationHistory()}
        </div>

        <div className="form-footer" style={{ display: "flex", gap: "20px" }}>
          <button
            onClick={() => {
              navigate(-1);
            }}
            type="button"
            className="submit-btn"
            disabled={loading}
          >
            Back
          </button>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Processing..." : "Save and Next"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FormFillUpStep2;
